import api from './api'

const url = 'jobs'

const getActiveJobs = () => api.get(`${url}/find-active`);

export default {getActiveJobs}
